import React, { useState } from 'react'
import { isEmpty } from 'lodash'
import { format } from 'date-fns'
import { Calendar } from 'react-date-range'
import './style.scss'

const SingleDatePicker = ({ color = 'accent0', selectedDate = {}, toggleCalendar, hideOnChange, onChange, dateFormat }) => {

  const [currentSelectedDate, setCurrentSelectedDate] = useState(isEmpty(selectedDate) ? new Date() : selectedDate)

  const handleOnChange = (selected) => {
    setCurrentSelectedDate(selected)
    onChange(format(selected, dateFormat || 'dd/MM/yyyy'))
    hideOnChange && toggleCalendar && toggleCalendar(false)
  }

  return (
    <div className='viso-single-date-picker'>
      <div className='date-picker'>
        <div className='date-picker__calendar'>
          <div className={`calendar ${color}`}>
            <Calendar
              color={color}
              customClass={color}
              weekStartsOn={1}
              showPreview={true}
              dateDisplayFormat="d MMM yyyy"
              onChange={handleOnChange}
              date={currentSelectedDate}
            />
          </div>
        </div>
      </div>
    </div>
  )
}

export default SingleDatePicker